/*
  Selectorul de FANbox din cos.

  Datele: assets/fan-lockers.json, format compact generat de scripts/fan/fetch_lockers.py
    { j:[judete], o:[localitati],
      l:[[id, nume, idxJudet, idxLocalitate, adresa, zip, lat, lng, nonstop, marimi], ...] }
  `marimi` e masca de biti a sertarelor existente: 1=S, 2=M, 4=L.
  Se incarca o singura data, la prima deschidere a panoului (nu la incarcarea paginii) - fisierul
  are 319 KB si majoritatea clientilor nu-l deschid niciodata.

  Derivat din vechiul assets/delivery-choice.js (selectorul de easybox, scos in august cand
  SamedayApp a preluat alegerea lockerului). Diferentele fata de el, deliberate:
    - nu alege metoda de livrare, doar lockerul: metoda ramane a checkout-ului, iar easybox-ul
      e in continuare treaba SamedayApp - doua mecanisme peste aceeasi alegere ar fi o regresie;
    - salveaza doar id-ul FAN, nu si adresa: issue_awb.py cere de la FAN datele proaspete dupa id.
*/
(function () {
  'use strict';

  var ID = 0, NUME = 1, JUD = 2, LOC = 3, ADRESA = 4, NONSTOP = 8, MARIMI = 9;
  var MAX_RENDER = 60; // lista e virtualizata simplu: afisam primele N potriviri

  var COMBINING = /[̀-ͯ]/g;

  function fold(s) {
    // cautare fara diacritice: "Bucuresti" trebuie sa gaseasca si "Bucuresti" cu semne
    return (s || '').toLowerCase().normalize('NFD').replace(COMBINING, '');
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function sizes(mask) {
    var out = [];
    if (mask & 1) out.push('S');
    if (mask & 2) out.push('M');
    if (mask & 4) out.push('L');
    return out.join('·');
  }

  class FanLocker extends HTMLElement {
    connectedCallback() {
      this.data = null;
      this.panel = this.querySelector('[data-locker-panel]');
      if (!this.panel) return; // cos peste 8 kg: blocul e doar informativ, fara selector
      this.list = this.querySelector('[data-locker-list]');
      this.count = this.querySelector('[data-locker-count]');
      this.status = this.querySelector('[data-locker-status]');
      this.county = this.querySelector('[data-locker-county]');
      this.search = this.querySelector('[data-locker-search]');

      this.addEventListener('click', this.onClick.bind(this));
      this.county.addEventListener('change', this.render.bind(this));
      this.search.addEventListener('input', this.debounced());
      this.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !this.panel.hidden) this.close();
      }.bind(this));
    }

    debounced() {
      var t;
      return function () {
        clearTimeout(t);
        t = setTimeout(this.render.bind(this), 120);
      }.bind(this);
    }

    onClick(e) {
      if (e.target.closest('[data-locker-open]')) return this.open();
      if (e.target.closest('[data-locker-close]')) return this.close();
      if (e.target.closest('[data-locker-clear]')) return this.save('', '');
      var pick = e.target.closest('[data-locker-id]');
      if (pick) return this.choose(pick.getAttribute('data-locker-id'));
    }

    open() {
      this.panel.hidden = false;
      if (window.TDOverlay) {
        window.TDOverlay.lock();
        this.releaseFocus = window.TDOverlay.trapFocus(this.panel);
      }
      this.load().then(function () { this.search.focus(); }.bind(this));
    }

    close() {
      // Garda: fara ea, un close() pe un panou care n-a fost deschis ar chema unlock() fara
      // lock pereche si ar strica numaratorul comun al overlay-urilor (scroll-ul paginii ar
      // ramane blocat). Aceeasi capcana era si in selectorul de easybox.
      if (this.panel.hidden) return;
      this.panel.hidden = true;
      if (window.TDOverlay) window.TDOverlay.unlock();
      if (this.releaseFocus) { this.releaseFocus(); this.releaseFocus = null; }
      var btn = this.querySelector('[data-locker-open]');
      if (btn) btn.focus();
    }

    load() {
      if (this.loading) return this.loading;
      if (this.data) return Promise.resolve();
      this.count.textContent = 'Se incarca lista de lockere…';
      this.loading = fetch(this.dataset.src)
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.json();
        })
        .then(function (d) {
          this.data = d;
          this.fillCounties();
          this.render();
        }.bind(this))
        .catch(function () {
          this.loading = null; // altfel o eroare de retea blocheaza definitiv orice reincercare
          this.count.textContent =
            'Lista de lockere nu s-a putut încărca. Poți alege „Livrare la FANbox ' +
            '(FAN Courier)” la finalizarea comenzii și revenim noi cu un mesaj pentru ' +
            'alegerea lockerului.';
          this.list.innerHTML = '';
        }.bind(this));
      return this.loading;
    }

    fillCounties() {
      var frag = document.createDocumentFragment();
      this.data.j.map(function (name, i) { return [name, i]; })
        .sort(function (a, b) { return a[0].localeCompare(b[0], 'ro'); })
        .forEach(function (pair) {
          var o = document.createElement('option');
          o.value = String(pair[1]);
          o.textContent = pair[0];
          frag.appendChild(o);
        });
      this.county.appendChild(frag);
    }

    matches() {
      var q = fold(this.search.value.trim());
      var cty = this.county.value === '' ? null : Number(this.county.value);
      var d = this.data;
      return d.l.filter(function (r) {
        if (cty !== null && r[JUD] !== cty) return false;
        if (!q) return true;
        return fold(r[NUME] + ' ' + d.o[r[LOC]] + ' ' + r[ADRESA]).indexOf(q) !== -1;
      });
    }

    render() {
      if (!this.data) return;
      var rows = this.matches();
      var shown = rows.slice(0, MAX_RENDER);
      var d = this.data;
      var selected = this.dataset.selectedId;

      this.count.textContent = rows.length === 0
        ? 'Niciun FANbox găsit. Încearcă altă localitate sau alt județ.'
        : rows.length + (rows.length === 1 ? ' FANbox găsit' : ' lockere găsite') +
          (rows.length > shown.length
            ? ' — primele ' + shown.length + ' afișate, caută mai precis'
            : '');

      this.list.innerHTML = shown.map(function (r) {
        var isSel = String(r[ID]) === selected;
        var marimi = sizes(r[MARIMI]);
        return '<li><button type="button" class="td-fan__item' + (isSel ? ' is-selected' : '') +
          '" data-locker-id="' + esc(r[ID]) + '">' +
          '<span class="td-fan__name">' + esc(r[NUME]) + '</span>' +
          '<span class="td-fan__addr">' + esc(r[ADRESA]) + ', ' + esc(d.o[r[LOC]]) +
          ', ' + esc(d.j[r[JUD]]) + '</span>' +
          '<span class="td-fan__tags">' +
          (r[NONSTOP] ? '<span class="td-fan__tag">non-stop</span>' : '') +
          (marimi ? '<span class="td-fan__tag">casete ' + marimi + '</span>' : '') +
          '</span></button></li>';
      }).join('');
    }

    choose(id) {
      var d = this.data;
      var row = d.l.find(function (r) { return String(r[ID]) === String(id); });
      if (!row) return;
      var label = row[NUME] + ' — ' + row[ADRESA] + ', ' + d.o[row[LOC]] + ', ' + d.j[row[JUD]];
      this.save(label, String(row[ID]));
    }

    paint(label) {
      var current = this.querySelector('[data-locker-current]');
      var open = this.querySelector('[data-locker-open]');
      var clear = this.querySelector('[data-locker-clear]');
      if (current) {
        current.innerHTML = label
          ? '<span class="td-fan__badge">FANbox ales</span><strong>' + esc(label) + '</strong>'
          : '<span class="td-fan__none">Niciun FANbox ales inca.</span>';
      }
      if (open) open.textContent = label ? 'Schimba FANbox-ul' : 'Alege un FANbox';
      if (clear) clear.hidden = !label;
      this.render(); // marcheaza in lista lockerul acum selectat
    }

    save(label, id) {
      var btn = this.querySelector('[data-locker-open]');
      if (btn) btn.disabled = true;
      if (this.status) {
        this.status.textContent = '';
        this.status.classList.remove('is-error');
      }

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { 'FANbox': label, 'FANbox ID': id } })
      }).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        // Actualizam blocul in loc, NU reincarcam pagina: in cosul glisant o reincarcare ar
        // inchide sertarul exact cand clientul tocmai a ales lockerul. Nu e o a doua sursa de
        // adevar - aici nu se calculeaza nimic (niciun pret, niciun total), doar se afiseaza
        // textul pe care tocmai l-am trimis. La orice re-randare a sectiunii, Shopify il
        // rescrie oricum din atributele cosului.
        if (btn) btn.disabled = false;
        // Pe /cart blocul exista de DOUA ori: in pagina si in cosul glisant (randat de
        // layout/theme.liquid pe orice pagina). Alegerea facuta intr-unul trebuie sa apara si in
        // celalalt, altfel pagina ramane pe „Niciun FANbox ales" dupa ce clientul tocmai a ales.
        document.querySelectorAll('fan-locker').forEach(function (el) {
          el.dataset.selectedId = id;
          if (typeof el.paint === 'function') el.paint(label);
        });
        this.close();
      }.bind(this)).catch(function () {
        if (btn) btn.disabled = false;
        if (this.status) {
          this.status.textContent = 'Nu am putut salva alegerea. Încearcă din nou.';
          this.status.classList.add('is-error');
        }
      }.bind(this));
    }
  }

  if (!customElements.get('fan-locker')) {
    customElements.define('fan-locker', FanLocker);
  }
})();
